import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootStateType } from '@/core/store/store';
import tokens from '@/payroll-period/tokens.json';

type PageLoadingStateType = {
  isLoading: boolean;
  isNoData: boolean;
};
const payrollPeriodInitialState = {
  postSave: 0,
  period: undefined as string | undefined,
  pageLoadingState: {
    isLoading: true,
    isNoData: false,
  },
  addEmployee: {
    disabled: true,
    title: tokens['PLEASE_WAIT_LIST'],
  },
  resetBatch: {
    disabled: true,
  },
};
const PP_STORE_KEY = 'payrollPeriod';

const payrollPeriodSlice = createSlice({
  name: 'payrollPeriod',
  initialState: payrollPeriodInitialState,
  reducers: {
    addPostSave(state) {
      state.postSave += 1;
    },
    resetPostSave(state) {
      state.postSave = 0;
    },
    setPeriod(state, action: PayloadAction<string>) {
      state.period = action.payload;
    },
    setAddEmployeeButtonStatus(state, { payload }: PayloadAction<boolean>) {
      state.addEmployee.disabled = payload;
    },
    setAddEmployeeButtonTitle(state, { payload }: PayloadAction<string>) {
      state.addEmployee.title = payload;
    },
    setResetBatchButtonStatus(state, { payload }: PayloadAction<boolean>) {
      state.resetBatch.disabled = payload;
    },
    setPageLoadingState(state, action: PayloadAction<PageLoadingStateType>) {
      state.pageLoadingState.isLoading = action.payload.isLoading;
      state.pageLoadingState.isNoData = action.payload.isNoData;
    },
  },
});

const getPostSaveFromStore = (state: RootStateType) => state.payrollPeriod.postSave;
const getAddEmployeeState = (state: RootStateType) => state.payrollPeriod.addEmployee;
const getResetButtonState = (state: RootStateType) => state.payrollPeriod.resetBatch;
const getAllCounts = (state: RootStateType) => state.common.counts;
const getPageLoadingState = (state: RootStateType) => state.payrollPeriod.pageLoadingState;

const getCurrentEmployerId = createSelector(
  [getAllCounts, (state, period) => period],
  (allCounts, period) => {
    const currentPeriod = period && allCounts ? allCounts[period] : undefined;
    return currentPeriod ? currentPeriod.employerId : undefined;
  },
);

export default payrollPeriodSlice.reducer;
export const {
  addPostSave,
  resetPostSave,
  setAddEmployeeButtonStatus,
  setAddEmployeeButtonTitle,
  setPeriod,
  setResetBatchButtonStatus,
  setPageLoadingState,
} = payrollPeriodSlice.actions;
export {
  PP_STORE_KEY,
  getPostSaveFromStore,
  getAddEmployeeState,
  getCurrentEmployerId,
  getResetButtonState,
  getPageLoadingState,
};
